import { CompaniesByUserModel, CompaniesByUserModelAPI } from '../../../../models';

export const getCompaniesByUserAdapters = (
    response: CompaniesByUserModelAPI[]
): CompaniesByUserModel[] => {
    return response
        ? response.map((company) => {
              return {
                  company: company.company,
                  user: company.user,
              };
          })
        : [];
};
